import { Button, StyledButton } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const CustomIconButton = styled(Button)`
	${({ theme }) => {
		const iconOnlyPadding =
			theme.components.button.sizes.default.paddingVertical;
		return css`
			min-width: 0;
			padding: ${iconOnlyPadding};

			${StyledButton.Icon} {
				font-size: 20px;
			}

			${StyledButton.Label} {
				display: flex;
				justify-content: center;
				align-items: center;

				svg {
					width: 20px;
					height: 20px;
				}
			}
		`;
	}}
`;
